export const QUALITY_LAST_N_WILDIX = 'QUALITY_LAST_N_WILDIX';
export const QUALITY_VIDEO_RES_WILDIX = 'QUALITY_VIDEO_RES_WILDIX';
export const QUALITY_LABEL_SHOW = 'QUALITY_LABEL_SHOW';
